import axios from "axios";
import config from "./config";
export default {
    async getScript(id, custom) {
        try {
            let url;
            if (custom) {
                url =
                    config.app_url == undefined
                        ? ""
                        : config.app_url + "components/script/" + id;
            }
            else {
                url = config.openkit_url;
            }
            let { data: component } = await axios.get(url, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return component;
        }
        catch (error) {
            return null;
        }
    },
    async getCss(id, custom) {
        try {
            let url;
            if (custom) {
                url =
                    config.app_url == undefined
                        ? ""
                        : config.app_url + "components/css/" + id;
            }
            else {
                url = config.openkit_url;
            }
            let { data: css } = await axios.get(url, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return css;
        }
        catch (error) {
            return null;
        }
    },
};
